import React from "react";

import "./styles.scss";
import { ChatModels } from "..";

const InitializeChat = ({ selectModel }) => {
    return (
        <div className="initialize-chat-section">
            <div className="section-container">
                <div className="title-section">DOC Research</div>
                <div className="description-section">Select any AI model to start conversation</div>
                <div className="model-options-section">
                    {ChatModels?.map((model) => {
                        return (
                            <div className="model-card" key={model.id} onClick={() => selectModel({ model: model })}>
                                <div className="model-icon">{model.icon}</div>
                                <div className="model-name">{model.title}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default InitializeChat